import React, { forwardRef } from "react";
import { createPortal } from "react-dom";
import { Paper, IconButton, Tooltip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const ComposeSelectionFormatToolbar = forwardRef(function ComposeSelectionFormatToolbar(
  { x, y, formats, onApply },
  ref
) {
  const theme = useTheme();
  const { t } = useTranslation("chat");
  if (x == null || y == null || !formats?.length) return null;

  const z = (theme.zIndex?.modal ?? 1300) + 2;

  return createPortal(
    <Paper
      ref={ref}
      elevation={4}
      role="toolbar"
      aria-label={t("input.formatToolbarAria")}
      onMouseDown={(e) => e.preventDefault()}
      sx={{
        position: "fixed",
        left: x,
        top: y,
        transform: "translate(-50%, calc(-100% - 10px))",
        zIndex: z,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 0.25,
        px: 0.75,
        py: 0.25,
        borderRadius: 999,
        bgcolor: "background.paper",
        color: "text.primary",
        border: 1,
        borderColor: "divider",
        boxShadow: 3,
        maxWidth: "min(96vw, 520px)",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {formats.map((entry) => {
        const titleKey = entry.tooltipKey || entry.tooltip;
        const title = titleKey && titleKey.includes(".") ? t(titleKey) : titleKey || "";
        return (
          <Tooltip key={entry.key || titleKey} title={title}>
            <IconButton
              size="small"
              color="inherit"
              onClick={() => onApply(entry)}
              aria-label={title}
              sx={{
                color: "text.primary",
                "&:hover": { bgcolor: "action.hover", color: "primary.main" },
              }}
            >
              {entry.icon}
            </IconButton>
          </Tooltip>
        );
      })}
    </Paper>,
    document.body
  );
});

export default ComposeSelectionFormatToolbar;
